// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** @deprecated: this file is about to be removed */
.n-action-resize {
  position: absolute;
  -webkit-user-select: none;
          user-select: none;
}
.n-action-resize--orientation-horizontal {
  height: 100%;
  right: 0;
  top: 0;
  cursor: col-resize;
}
*:hover > .n-action-resize--orientation-horizontal.n-action-resize--highlight {
  border-right: 1px dotted color-mix(in srgb, var(--color-content-secondary) 40%, transparent);
}
.n-action-resize--orientation-horizontal.n-action-resize--highlight.n-action-resize:hover {
  background-color: oklch(from var(--color-accent-background-base) l c h / 0.3);
  border-right: 1px dotted var(--color-accent-background-base);
}
.n-action-resize--orientation-horizontal.n-action-resize--highlight.n-action-resize--is-resizing,
*:hover > .n-action-resize--orientation-horizontal.n-action-resize--highlight.n-action-resize--is-resizing {
  border-right: 1px dotted var(--color-accent-background-base);
}
.n-action-resize--orientation-horizontal.n-action-resize--handler-sm {
  width: 5px;
}
.n-action-resize--orientation-horizontal.n-action-resize--handler-md {
  width: 7px;
}
.n-action-resize--orientation-vertical {
  width: 100%;
  left: 0;
  bottom: 0;
  cursor: row-resize;
}
.n-action-resize--orientation-vertical.n-action-resize--handler-sm {
  height: 5px;
}
.n-action-resize--orientation-vertical.n-action-resize--handler-md {
  height: 7px;
}
.n-action-resize--orientation-both {
  cursor: nwse-resize;
  bottom: 0;
  right: 0;
}
.n-action-resize--orientation-both.n-action-resize--handler-sm {
  width: 5px;
  height: 5px;
}
.n-action-resize--orientation-both.n-action-resize--handler-md {
  width: 7px;
  height: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/core-ui/components/table/actions/ResizeAction/ResizeAction.less"],"names":[],"mappings":"AAAA,mDAAmD;AAGnD;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;AADF;AAKE;EACE,YAAA;EACA,QAAA;EACA,MAAA;EACA,kBAAA;AAHJ;AAME;EACE,4FAAA;AAJJ;AAOE;EACE,6EAAA;EACA,4DAAA;AALJ;AAQE;;EAEE,4DAAA;AANJ;AASE;EACE,UAAA;AAPJ;AAUE;EACE,UAAA;AARJ;AAaE;EACE,WAAA;EACA,OAAA;EACA,SAAA;EACA,kBAAA;AAXJ;AAcE;EACE,WAAA;AAZJ;AAeE;EACE,WAAA;AAbJ;AAiBE;EACE,mBAAA;EACA,SAAA;EACA,QAAA;AAfJ;AAkBE;EACE,UAAA;EACA,WAAA;AAhBJ;AAmBE;EACE,UAAA;EACA,WAAA;AAjBJ","sourcesContent":["@import \"~neptune-core-ui/less/variables.less\";\n\n\n.n-action-resize {\n  position: absolute;\n  user-select: none;\n\n  // horizontal\n\n  &--orientation-horizontal {\n    height: 100%;\n    right: 0;\n    top: 0;\n    cursor: col-resize;\n  }\n\n  *:hover > &--orientation-horizontal&--highlight {\n    border-right: 1px dotted @TableAction-hover-color;\n  }\n\n  &--orientation-horizontal&--highlight&:hover {\n    background-color: oklch(from var(--color-accent-background-base) l c h / 0.3);\n    border-right: 1px dotted var(--color-accent-background-base);\n  }\n\n  &--orientation-horizontal&--highlight&--is-resizing,\n  *:hover > &--orientation-horizontal&--highlight&--is-resizing {\n    border-right: 1px dotted var(--color-accent-background-base);\n  }\n\n  &--orientation-horizontal&--handler-sm {\n    width: 5px;\n  }\n\n  &--orientation-horizontal&--handler-md {\n    width: 7px;\n  }\n\n  // vertical\n\n  &--orientation-vertical {\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    cursor: row-resize;\n  }\n\n  &--orientation-vertical&--handler-sm {\n    height: 5px;\n  }\n\n  &--orientation-vertical&--handler-md {\n    height: 7px;\n  }\n\n  // both\n  &--orientation-both {\n    cursor: nwse-resize;\n    bottom: 0;\n    right: 0;\n  }\n\n  &--orientation-both&--handler-sm {\n    width: 5px;\n    height: 5px;\n  }\n\n  &--orientation-both&--handler-md {\n    width: 7px;\n    height: 7px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
